import React from "react";
import { useContext } from "react";
import { Link } from "react-router-dom";
import AuthContext from "../../store/auth-context";

const Login = (props) => {
  const authCtx = useContext(AuthContext);

  let benvenuto = "";
  let path = "";

  if (props.userData !== null ) {
  benvenuto = "Ciao " + props.userData.nome;
    path = "/profilo/dati";
  } else {
    benvenuto = "Accedi";
    path = "/login";
  }

  return (
    <div className="utente">
      <Link to={path}>
        {!props.textToRight || props.textToRight === false ? (
          <div className="nome_utente">
            <p>{benvenuto}</p>
          </div>
        ) : null}
        <div className="ico_utente">
          <img src="/images/login_on.svg" alt="login" />
        </div>
        {props.textToRight && props.textToRight === true ? (
          <div className="nome_utente">
            <p>{benvenuto}</p>
          </div>
        ) : null}
      </Link>
    </div>
  );
};
export default Login;
